export default "__VITE_ASSET__0OtGR5dc__"